export const ProjectsLoadingState = () => {
  return (
    <div className="flex items-center justify-center h-full min-h-[calc(100svh-54px)]">
      <div className="text-muted-foreground">Loading projects...</div>
    </div>
  );
};
